import React from "react";

import {CircularProgress} from "@mui/joy";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import SliceCard from "./SliceCard";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import withRouter from "../../utils/withRouter";


class SliceList extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            slices: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveSlices();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveSlices();
        }
    }

    async retrieveSlices(){
        const api = new BaseApi();
        let url = 'slice';
        let params = {
            operator: this.context.subscriberObject.id,
            ...this.props.queryParams
        }
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        this.setState(
            {
                slices: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
         if (!this.state.slices || !this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <CommonPaginatedComponentList
                title={this.props.title}
                pages={this.state.pages}
                pageNumber={this.state.pageNumber}
                url={this.props.url}
                data={this.state.slices}
                component={SliceCard}
                componentKeyword={'slice'}
                componentProps={{
                    showOpportunity: true,
                    variant: 'soft',
                }}
                paginationCallback={this.retrieveSlices.bind(this)}
                callBack={this.retrieveSlices.bind(this)}
            />
        )
    }
}

export default withRouter(SliceList)